import { useEffect, useState } from "react";

import RegistrationDetails from "../../Components/RegistrationDetails";
import VenderDetails from "../../Components/VenderDetails";
// import VerifyMobileNumber from '../../Components/VerifyMobileNumber';
import RegistrationMessage from "../../Components/RegistrationMessage";
// import { useNavigate } from 'react-router-dom';
import OwnershipDetails from "../../Components/OwnershipDetails";
// import LanguageSwitcher from '../../Components/LanguageSwitcher';
import Cookies from "js-cookie";
import { useShopDetailsData } from "../../API_Master/GetAPI";
// import VendorDashboardHeader from '../../Components/VendorDashboardHeader';
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "../../Components/LanguageSwitcher";
import { mainRouteInitial } from "../../Data/Constant";

const VenderRegistration = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(
    Cookies.get("IsStep1Completed") == "false" ? 0 : Cookies.get("IsStep2Completed") == "false" ? 1 : Cookies.get("IsStep3Completed") == "false" ? 2 : 0,
  );
  const { data: shopDetailsData = [], refetch, isLoading } = useShopDetailsData(Cookies.get("NIGHT_EYE_SHOP_DETAIL_ID"), Cookies.get("VENDER_NIGHT_EYE_USER_ID"));
  const steps = [
    //   {
    //   component: VerifyMobileNumber,
    //   title: 'Verify Mobile Number',
    //   desc: 'Enter the 6-digit OTP sent to your registered mobile number',
    // },
    {
      component: RegistrationDetails,
      title: "Basic Shop Information",
      desc: "Enter shop details, location, operating hours, and helper information",
      isCompleted: Cookies.get("IsStep1Completed"),
    },
    {
      component: VenderDetails,
      title: "Vendor Identity Verification",
      desc: "Provide your personal details and upload Aadhaar card for secure verification",
      isCompleted: Cookies.get("IsStep2Completed"),
    },
    {
      component: OwnershipDetails,
      title: "Shop Ownership Information",
      desc: "Please verify and document the legal status of the shop premises.",
      isCompleted: Cookies.get("IsStep3Completed"),
    },

    {
      component: RegistrationMessage,
      title: "Registration Complete",
      desc: "Your vendor registration has been successfully submitted!",
    },
  ];
  const handleRegisterNewVendor = () => {
    Cookies.set("IsStep1Completed", false);
    Cookies.set("IsStep2Completed", false);
    Cookies.set("IsStep3Completed", false);
    Cookies.remove("VENDER_NIGHT_EYE_USER_ID");

    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };
  useEffect(() => {
    if (Cookies.get("NIGHT_EYE_SHOP_DETAIL_ID")) {
      refetch();
    }
  }, [currentStep]);

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [currentStep]);
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-slate-600 dark:text-slate-300">Loading shop details...</p>
        </div>
      </div>
    );
  }

  const CurrentComponent = steps[currentStep].component;
  const handleGoBack = () => {
    Cookies.set("IsStep1Completed", true);
    Cookies.set("IsStep2Completed", true);
    Cookies.set("IsStep3Completed", true);
    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}

      {/* <VendorDashboardHeader isLanguageSwitcher={true} /> */}
      {/* Main Content */}
      {Cookies.get("VenderMobileNo") && (
        <div
          className="flex items-center gap-3 px-5 py-2.5 bg-amber-50/80 dark:bg-amber-950/40 
                border border-amber-200 dark:border-amber-800/50 rounded-xl shadow-md"
        >
          <span className="flex h-2.5 w-2.5 rounded-full bg-amber-500 animate-pulse" />
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-amber-800 dark:text-amber-300">Currently Performing Action on Shop : {Cookies.get("VenderMobileNo")}</span>
          </div>
        </div>
      )}
      <main className=" relative flex-1 w-full mx-auto px-8 py-8">
        <button
          onClick={handleGoBack}
          className="flex items-center gap-2 
                px-4 py-2 mb-4 mt-0
                text-slate-700 dark:text-slate-300 
                hover:text-indigo-600 dark:hover:text-indigo-400
                bg-white dark:bg-slate-800 
                border border-slate-300 dark:border-slate-700 
                rounded-lg 
                shadow-sm 
                hover:shadow 
                transition-all"
        >
          {/* <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          > */}
          {/* <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            /> */}
          {/* </svg> */}
          <span className="font-medium">View Shop Details</span>
        </button>
        <div className="languageSwitcherMain flex mb-2  items-center gap-4 text-xs font-bold font-medium text-slate-600 dark:text-slate-400">
          <button
            type="button"
            onClick={() => handleRegisterNewVendor()}
            className="bg-red-600 text-sm font-medium h-9 w-100  text-white px-2 rounded flex items-center gap-2 focus:outline-none"
          >
            <span className="material-symbols-outlined text-2xl">storefront</span>
            {/* Avatar with initials */}
            Register New Vendor
          </button>
          <a>
            <LanguageSwitcher />
          </a>
        </div>
        <div className="mb-8 ">
          {/* Title & Step Indicator */}
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
            <div>
              <h1 className="text-3xl font-black leading-tight tracking-tight text-[#0d141b] dark:text-white mb-2">{steps[currentStep].title}</h1>
              <p className="text-[#4c739a] dark:text-slate-400 font-medium">{steps[currentStep].desc}</p>
            </div>
            <div className="flex items-center gap-2 text-xs font-bold font-medium bg-white dark:bg-[#1A2633] py-2 px-4 rounded-full border border-slate-200 dark:border-slate-700 shadow-sm">
              <span className="text-primary">Step {currentStep + 1}</span>
              <span className="text-slate-300 dark:text-slate-600">/</span>
              <span className="text-slate-500 dark:text-slate-400">Step {steps.length}</span>
            </div>
          </div>
          {/* Progress Bar */}
          <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2 mb-8">
            <div className="bg-primary h-2 rounded-full transition-all duration-500 ease-out" style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }} />
          </div>
        </div>
        {/* Current Step Content */}
        {/* <div className="bg-white dark:bg-[#1A2633] rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-8"> */}
        <CurrentComponent prevStep={prevStep} nextStep={nextStep} disabled={currentStep === 0} shopDetailsData={shopDetailsData} />
        {/* </div> */}
      </main>
    </div>
  );
};

export default VenderRegistration;
